import { TableCell } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { deleteDetailedStateTradeRemaining } from "../../../../Requests/deltaHedgeExe";
import { packetErrorHandler } from "../../../../Utils/requestUtils";
import Button from "../../../../Components/Button";
import FullScreenLoading from "../../../../Components/Loading/FullScreenLoading";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../../TableTemplate/tableTemplate";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: any;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = useState(false);

  const deleteRemainingHandler = () => {
    setLoading(true);
    deleteDetailedStateTradeRemaining(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell>
        <Button
          text="حذف باقی مانده"
          variant="outlined"
          onClick={deleteRemainingHandler}
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<any> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
